<div class="evidence-header">
  <div class="evidence-title-group">
    <span class="evidence-title">{{ title }}</span>
    @if (credentialEvidence.evidenceSnapshotTakenDate) {
      <button
        type="button"
        mat-icon-button
        class="evidence-info-icon"
        matTooltip="Evidence reflects the value as it was when the requirement was completed"
        matTooltipPosition="above"
        aria-label="Evidence reflects the value as it was when the requirement was completed"
      >
        <mat-icon class="mat-icon material-icons md-18">info</mat-icon>
      </button>
    }
  </div>

  <div class="evidence-toggle">
    @if (credentialEvidence.evidences.length) {
      <mat-slide-toggle
        color="primary"
        labelPosition="before"
        [(ngModel)]="showAllFields"
        (click)="$event.stopPropagation()"
      >
        Show empty evidences ({{ EmptyEvidenceCount() }})
      </mat-slide-toggle>
    }
  </div>
</div>
<ng-content></ng-content>
<div
  class="snapshots-container"
  [ngClass]="{ 'show-all-fields': showAllFields }"
>
  @for (evidence of credentialEvidence.evidences; track evidence) {
    <evidence-snapshot
      [isEditable]="!credentialEvidence.evidenceSnapshotTakenDate"
      [identifier]="credentialEvidence.identifier"
      [scenarioId]="scenarioId"
      [ngClass]="evidence.evidenceValue.length ? '' : 'isEmpty'"
      [evidence]="evidence"
      [showAllFields]="showAllFields"
      [openEvidenceFile]="openEvidenceDocumentInS3"
    >
    </evidence-snapshot>
  }
</div>
